import { defineStore } from "pinia";

type MessageHeaderVendor = {
  id: number;
  name: string;
  logo: string;
  initials: string;
};

type MessageHeaderState = {
  title: string;
  chatThreadType: string;
  vendor: MessageHeaderVendor | null;
  isLoading: boolean;
};

const defaultState: MessageHeaderState = {
  title: "",
  chatThreadType: "",
  vendor: null,
  isLoading: false,
};

export const useMessageHeaderStore = defineStore("messageHeader", {
  state: (): MessageHeaderState => ({ ...defaultState }),
  actions: {
    setHeader(payload: Partial<MessageHeaderState>) {
      Object.assign(this, payload);
    },
    reset() {
      Object.assign(this, defaultState);
    },
  },
});
